import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import LanguageToggle from './LanguageToggle';
import ThemeToggle from './ThemeToggle';
import Icon from './Icon';
import { AsideRings } from './illustrations';

export default function AuthLayout({ children }) {
  const { t } = useTranslation();
  const points = ['auth.aside_point1', 'auth.aside_point2', 'auth.aside_point3'];

  return (
    <div className="auth-screen">
      <aside className="auth-aside">
        <Logo />
        <div className="aside-visual">
          <AsideRings />
        </div>
        <div className="aside-body">
          <span className="eyebrow">{t('landing.eyebrow')}</span>
          <h2>{t('auth.aside_title')}</h2>
          <p style={{ marginBottom: 'var(--sp-5)' }}>{t('auth.aside_desc')}</p>
          <ul style={{ listStyle: 'none', display: 'grid', gap: 'var(--sp-3)' }}>
            {points.map((p) => (
              <li key={p} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', color: 'var(--text-2)', fontSize: 14 }}>
                <span style={{ color: 'var(--accent)', marginTop: 2, flexShrink: 0 }}>
                  <Icon name="check" size={16} />
                </span>
                {t(p)}
              </li>
            ))}
          </ul>
        </div>
      </aside>

      <main className="auth-main">
        <div className="auth-card">
          <div className="auth-topbar">
            <Logo />
            <div style={{ display: 'flex', gap: 8 }}>
              <ThemeToggle />
              <LanguageToggle />
            </div>
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
